/**
 * Admin guide 4 — when something goes wrong: what the engine does by
 * itself, when a person is needed, and what your own rules stop.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { DropGenEngineSettings } from '@trafficpulse/shared';

import { Rows, Tag, V } from '../guide-ui';

export const TroubleSection: FC<{ s: DropGenEngineSettings }> = ({ s }) => (
  <div className="flex flex-col gap-3">
    <Rows
      stamp="It continues by itself"
      head={['What happens', 'What the engine does']}
      rows={[
        ['SMSWiser stats limit (429)', <>Stops reading for this pass, keeps the last numbers; the next pass carries on.<Tag kind="auto" /></>],
        ['A send never reached SMSWiser', <>Stays a draft, sent again the next minute (counts toward the refusal limit).<Tag kind="auto" /></>],
        ['SMSWiser refused a send', <>Sent again the next minute; the country's refusal limit in a row (3 by default) halts auto-send until Resume.<Tag kind="person" label="a person after the limit" /></>],
        ['Unknown outcome', <>Crash mid-send, or “sending” <V>{s.stuckSendingMin} min</V>: asks SMSWiser — found = sent, not found = sent again, no answer = halt.<Tag kind="person" label="a person only if unknown" /></>],
        ['AI rate limit or timeout', <>Waits (Retry-After, else 2 s doubling to 60 s), up to <V>{s.aiAttempts}</V> tries, <V>{s.aiConcurrency}</V> calls at once, then a second pass; still failing → Errors + Slack, Retry failed.<Tag kind="auto" /></>],
        ['Server restart during a fill', <>The fill starts again within 2 minutes, only for drafts still without texts.<Tag kind="auto" /></>],
        ['Tracker slow or down', <>Serves the last answer: dynamic list groups up to <V>{s.groupTagsLastDays} days</V>, text rankings up to <V>{s.textRankingCopyHours} h</V>.<Tag kind="auto" /></>],
        ['A bad day', <>The stop-loss halts the group for the day; the kill switch stops the whole country.<Tag kind="rules" /></>],
      ]}
    />
    <p className="rounded-md bg-primary/5 px-3 py-2 text-xs text-foreground/85">
      Every problem lands in the <b>Errors</b> tab — what happened · why · what to do — and in the Slack thread, and closes by itself when the same work succeeds later.
    </p>
  </div>
);
